import {
  format,
  formatDistanceToNowStrict,
  formatDuration,
  intervalToDuration,
  startOfMonth,
  endOfMonth,
} from "date-fns";

const formatDate = (year, month) => {
  return format(new Date(year, month - 1), "MMM y");
};

const getPeriod = (startMonth, startYear, endMonth, endYear) => {
  return `${formatDate(startYear, startMonth)} - ${
    endMonth && endYear ? formatDate(endYear, endMonth) : "Now"
  }`;
};

const getDuration = (startMonth, startYear, endMonth, endYear) => {
  const isEndDate = endMonth && endYear;

  if (isEndDate) {
    const { years, months } = intervalToDuration({
      start: startOfMonth(new Date(startYear, startMonth - 1)),
      end: endOfMonth(new Date(endYear, endMonth - 1)),
    });

    return formatDuration({ years, months });
  } else {
    return formatDistanceToNowStrict(new Date(startYear, startMonth - 1));
  }
};

const getPeriodData = (startMonth, startYear, endMonth, endYear) => {
  return {
    period: getPeriod(startMonth, startYear, endMonth, endYear),
    duration: getDuration(startMonth, startYear, endMonth, endYear),
  };
};

export const PROJECTS = {
  MyClusters: "MyClusters",
  "Passion.io": "Passion.io",
  "appt-now": "appt-now",
  Diggity: "Diggity",
  Mittspor: "Mittspor",
  Omnistools: "Omnistools",
  Chekin: "Chekin",
  Sharekey: "Sharekey",
  Emirates: "Emirates",
  "Refinitiv Eikon": "Refinitiv Eikon",
};

export const experienceData = [
  {
    company: "EPAM",
    companyType: "Outsource",
    companyLink: "https://www.epam.com/",
    ...getPeriodData(10, 2019, 4, 2020),
    projects: [
      {
        projectName: PROJECTS["Emirates"],
        productLink: "https://www.emirates.com/",
        projectRole: "Front-end Developer",
        mainTech: "React",
        ...getPeriodData(10, 2019, 12, 2019),
        projectDescription:
          "The project was in the “Tourism and hospitality” domain. We were developing a part of the application for buying tickets, booking hotels, cars, airport/hotel transfers.",
        team: "A huge team of 40+ people, devided to 3 smaller teams, including Front-end developers, Back-end developers, QAs, Designers, Business Analytics, Scrum Master, Delivery Manager, Project managers",
        technologies: [
          "React, Redux, Redux-thunk",
          "SCSS, BEM",
          "Jest, Enzyme, Storybook",
          "GIT",
          "Gitflow",
          "Bitbucket",
          "A11y",
          "Scrum",
        ],
        responsibilities: [
          "Participating in daily meetings, retrospective sessions",
          "Created storybook for the specific components to visual testing in isolation",
          "Added a11y support for specific parts of application",
          "Fixed a lot of visual and logical bugs",
        ],
      },
      {
        projectName: PROJECTS["Refinitiv Eikon"],
        productLink: "https://solutions.refinitiv.com/eikon-trading-software",
        projectRole: "Front-end Developer",
        mainTech: "Vue",
        ...getPeriodData(2, 2020, 4, 2020),
        projectDescription:
          "A desktop application trading charts tool for monitoring information about finances, stocks etc.",
        technologies: [
          "Vue.js",
          "Elf Ui library",
          "Moment.js",
          "Gitlab",
          "GIT",
          "Scrum",
        ],
        responsibilities: [
          "Participating in daily meetings",
          "Communiation with team about requirements",
          "Fixed a lot of UI and logical bugs and issues",
        ],
      },
    ],
  },
  {
    company: "Sharekey Labs",
    companyType: "Product",
    companyLink: "https://sharekey.com/",
    ...getPeriodData(4, 2020, 8, 2020),
    projects: [
      {
        projectName: PROJECTS["Sharekey"],
        productLink: "https://sharekey.com/",
        projectRole: "Front-end Developer",
        mainTech: "React",
        ...getPeriodData(4, 2020, 8, 2020),
        projectDescription:
          "A high privacy, end-to-end encrypted, B2B desktop/mobile/web chat application for communication between teams, companies with high security and no metadata collection. We were already using the product while communicating with the team",
        team: "4 Front-end developers, 2 Back-end developers, 2 React-native Developers, 1 DevOps, 1 Designer, 1 QA, Project Manager",
        technologies: [
          "React",
          "Redux",
          "SCSS",
          "BEM",
          "Storybook",
          "Node.js",
          "Meteor",
          "MongoDB",
          "Github",
          "GIT",
          "Gitflow",
          "Code review",
          "Scrum",
        ],
        achievements: [
          "Introdused and injected BEM approach to the team",
          "Introdused and implemented Storybook for visual testing components in isolation and created a list of control components (buttons) from all app",
          "Refactored a lot of code and improved the performance of the application",
          "Created resize functionality of two app’s columns and rewrite the whole application to be responsive",
          "Proactively found and fixed a lot of UI imperfections",
        ],
        responsibilities: [
          "Bug fixes and performance improvements",
          "Implementing new features",
          "Code review",
          "Participating in planning, retroscpective sessions and estimating tasks",
        ],
      },
    ],
  },
  {
    company: "Exaft",
    companyType: "Outsource",
    companyLink: "https://exaft.com/",
    ...getPeriodData(12, 2020, 7, 2021),
    projects: [
      {
        projectName: PROJECTS["Chekin"],
        productLink: "https://chekin.com/",
        projectRole: "Front-end Developer",
        mainTech: "React",
        ...getPeriodData(12, 2020, 7, 2021),
        projectDescription:
          "A web application for desktop and mobile devices for automate check-ins in booking apps",
        team: "2 Front-end developers, 4 Back-end developers, 1 iOS developer, 1 Android developer, 1 DevOps, QA - On the client side",
        technologies: [
          "TypeScript",
          "React",
          "React-router",
          "React-query",
          "Styled-components",
          "react-hook-form",
          "Github",
          "GIT",
          "Gitflow",
          "Code review",
        ],
        achievements: [
          "Enhanced UX with camera permissions handling and denied messages, reducing errors and support requests.",
          "Improved forms by disabling autocomplete and adding leave confirmation modals, preventing data loss.",
          "Built booking report generation/export and import features, streamlining operations.",
          "Added default email language, max deposit validation, and optimized grid layouts, boosting efficiency.",
          "Refactored front-end with global styles and reusable components for maintainability and consistency.",
        ],
        responsibilities: [
          "Analyze and estimation features requirements",
          "Participating in regular calls with client to clarify requirements and make suggestions",
          "Implementing pages and complex forms, features with cooperation with back-end",
          "Doing Github releases",
        ],
      },
    ],
  },
  {
    company: "SolveQ",
    companyType: "Outsource",
    companyLink: "https://www.solveq.io/",
    ...getPeriodData(7, 2021, 12, 2022),
    projects: [
      {
        projectName: PROJECTS["Diggity"],
        productLink: "https://digitty.io/",
        projectRole: "Front-end Developer",
        mainTech: "React",
        projectDescription:
          "A project management web application tool based on artificial intelegency.",
        team: "1 Front-end developer (me), 3 Back-end developers, 1 Data scientist, Project manager",
        ...getPeriodData(7, 2021, 12, 2021),
        technologies: [
          "TypeScript",
          "React",
          "React-router",
          "React-query",
          "Styled-components",
          "react-hook-form",
          "REST",
          "GIT",
          "Gitflow",
        ],
        responsibilities: [
          "Being single in the Front-end team leading the front-end part of the project",
          "Participating in calls with client and back-end team to analyze requirements and make suggestions",
          "Improve application architecture by creating reusable layout components and refactoring the old code",
          "Create pages and features with cooperation with back-end",
          "Participating in daily meetings, planning sessions and estimating tasks",
          "Participating in demo sessions where I was preseting work done by me",
        ],
      },
      {
        projectName: PROJECTS["Mittspor"],
        productLink: "https://www.mittspor.com/",
        projectRole: "Front-end Developer",
        mainTech: "React-Native",
        projectDescription:
          "A second project with newest version of a mobile application for pet tracking devices (New Generation Tracker)",
        ...getPeriodData(1, 2022, 8, 2022),
        team: "2 Front-end developers, 1 Back-end developer, Designer, Project manager, Support from the first version app's team",
        technologies: [
          "TypeScript",
          "React",
          "React-native",
          "Redux",
          "Styled-components",
          "Storybook",
          "GIT",
          "Gitflow",
          "Code review",
          "Scrum",
        ],
        responsibilities: [
          "Bootstrap and run the project from scratch",
          "Install necessary tools and doing necessary setup for them",
          "Tight collaboration with designer adjusting layouts and components",
          "Collaboration with the team of first version of application making common shared components library for two projects",
          "Creating pages and components for a mobile app",
        ],
      },
      {
        projectName: PROJECTS["Omnistools"],
        productLink: "https://www.omnistools.com/",
        projectRole: "Frontend Developer",
        mainTech: "React",
        projectDescription:
          "OmnisTools - analytics software tracking efficiencies of labor. It was needed to rewrite the legacy version of the project using modern technologies and approach",
        ...getPeriodData(8, 2022, 12, 2022),
        team: "3 Front-end developers, 2 Back-end developers, 1 QA, 1 DevOps, Designer, Progect manager",
        technologies: [
          "TypeScript",
          "React",
          "React-router",
          "React-query",
          "react-hook-form",
          "Styled-components",
          "React-testing-library",
          "Chakra-Ui",
          "Feature Sliced Design",
          "GIT",
          "Gitflow",
          "Code review",
          "Scrum",
        ],
        responsibilities: [
          "Bootstrap and run the project from scratch",
          "Install necessary tools and doing necessary setup for them",
          "Analyze requirements and make suggestions",
          "Participating in daily meetings, retrospective and planning sessions, estimating tasks",
          "Creating components, tables, forms and pages",
          "Writing unit tests",
        ],
      },
    ],
  },
  {
    company: "Medify.me sp. z o.o.",
    companyType: "Product",
    companyLink: "https://twojeznamiona.pl/",
    ...getPeriodData(4, 2023, 12, 2023),
    projects: [
      {
        projectName: PROJECTS["appt-now"],
        productLink: "https://appt-now.pl/",
        projectRole: "Full-stack Developer",
        mainTech: "React, Node.js",
        projectDescription:
          "A B2B and B2C tool for create and handle appointments for different medical companies",
        ...getPeriodData(4, 2023, 12, 2023),
        team: "3 freelance full-stack developers, CTO",
        technologies: [
          "TypeScript",
          "React",
          "React-router",
          "React-query",
          "react-hook-form",
          "Styled-components",
          "Gatsby",
          "Node.js",
          "Express.js",
          "PostgreSQL",
          "Sequelize",
          "Back-end migrations",
          "dbdiagram.io",
          "Cron",
          "Graphile-worker",
          "email-templates",
          "Unit testing: Chai, Mocha, Sinon",
          "GIT",
          "Gitflow",
          "Code review",
          "Scrum",
        ],
        achievements: [
          "Designed and implemented a workflow automation system for appointments, notifications, and patient satisfaction (including rescheduling and review/rating workflows), reducing manual admin tasks by ~40% and increasing patient follow-up completion rates by 25%.",
          "Built a robust template and notification engine (SMS & email with personalization, variables, previews, custom emails, and campaigns), cutting setup time for communications by 60% and boosting engagement rates by ~30%.",
          "Enhanced appointment and patient management, adding virtual appointments, conflict-aware rescheduling, reviews/ratings, group assignments, and exports — improving scheduling efficiency by 35% and driving a 20% increase in patient satisfaction survey responses.",
          "Improved admin and practice settings, including invoicing, group practice configuration, specialist procedures with price ranges, and entity soft-delete — reducing configuration errors by 50% and enabling multi-location practices to manage data 2x faster.",
          "Led technical upgrades and refactoring, including React Admin from v3 to v4.11.2 migration, reusable UI components, and performance optimizations — cutting page load times by ~25% and reducing maintenance overhead for developers by 40%.",
        ],
        responsibilities: [
          "Independently familiarize myself with complex product and technical documentation.",
          "Analyze product requirements, identify gaps, and propose effective solutions for fulfillment.",
          "Design architecture for new features, creating tables, and establishing relations between them.",
          "Conduct manual testing on all implemented features.",
          "Write unit tests.",
          "Proactively approach projects to deliver high-quality user and development experiences.",
          "Implement and deliver full-stack epics and features.",
          "Refactor, fix bugs, and enhance code quality.",
          "Implemented a responsive landing page for a marketing campaign: https://nawlasnejskorze.org/.",
        ],
      },
    ],
  },
  {
    company: "Passion.io",
    companyType: "Product",
    companyLink: "https://passion.io/",
    ...getPeriodData(1, 2024, 4, 2025),
    projects: [
      {
        projectName: PROJECTS["Passion.io"],
        productLink: "https://passion.io/",
        projectRole: "Full-stack Developer",
        mainTech: "React-Native, Node.js",
        projectDescription:
          "A no-code platform for creating mobile applications with interactive content",
        ...getPeriodData(1, 2024, 4, 2025),
        team: "3 developers, QA, Designers, PM",
        technologies: [
          "TypeScript",
          "React-native",
          "expo-router",
          "GraphQL",
          "Formik",
          "Styled-components",
          "Node.js",
          "Express.js",
          "PostgreSQL",
          "GIT",
          "Code review",
          "Agile",
          "Amplitude",
          "ConfigCat",
        ],
        achievements: [
          "Developed availability selectors feature which enables creators to choose visibility settings for products on the selling page, contributing to creator CSAT score increase from ~40% to ~60%",
          "Developed User Input Widgets, which enables creators to gather inputs from end users and react accordingly, resulting in +50% improvement in End User d7 Retention (from ~30% to ~45%)",
          "Developed new onboarding flow that streamlines the creator experience and improves user engagement, leading to +30% increase in Creator d7 Retention (from ~50% to ~65%)",
        ],
        responsibilities: [
          "Working in a cross-platform environment, ensuring the quality of web responsiveness, mobile, and native views.",
          "Closely collaborating with the Designers team, making valuable suggestions and clarifying instructions.",
          "Code review",
          "Participating in feature rollouts and iterative improvements where experiments were used to validate design or functionality changes.",
          "Adding new functionalities.",
          "Analysise, reporting and resolving product tech debt, bugs and issues.",
          "Proactively approaching projects to deliver high-quality user and development experiences.",
        ],
      },
    ],
  },
  {
    company: "MyClusters",
    companyType: "Product",
    companyLink: "https://myclusters.nl/",
    ...getPeriodData(8, 2025),
    projects: [
      {
        projectName: PROJECTS["MyClusters"],
        productLink: "https://myclusters.nl/",
        projectRole: "Mobile Developer",
        mainTech: "React-Native",
        ...getPeriodData(8, 2025),
        projectDescription:
          "A React Native mobile app for tracking cluster headaches, treatments, and related health signals (sleep, weather, workouts). Cross-platform (iOS/Android) with a Django REST backend.",
        team: "A team of 7 engineers (mobile, backend, full-stack), Designer, Product Manager, QA",
        technologies: [
          "TypeScript",
          "React-Native",
          "Expo",
          "Expo Router",
          "TanStack Query",
          "Zustand",
          "React Hook Form",
          "Zod",
          "i18next",
          "dayjs",
          "Jest, jest-expo",
          "Sentry",
          "ConfigCat",
          "HealthKit",
          "HealthConnect",
          "RevenueCat",
          "GIT",
          "Github",
          "Code review",
          "Agile",
        ],
        achievements: [
          "Built the full treatment management flow end-to-end — medication, supplement and alternative-therapy entry forms with dynamic frequency/dosage, time pickers, reminder scheduling, edit/delete, pagination, and a home-screen widget surfacing today’s medications with taken/dismiss actions.",
          "Shipped the subscriptions & paywall flow — paywall screen, custom free-tier gating, and integrated RevenueCat with subscription products configured in App Store Connect and Google Play Console.",
          "Delivered the reports & charts surface — tabbed reports navigation, weather forecast widget with range picker, workout and sleep-phase charts, HealthKit/HealthConnect integration, and per-platform empty states.",
          "Replaced the previous Crowdin OTA translation service with a custom DeepL-based pipeline which allows instantly translate newly added terms with one line command",
          "Wired up Sentry for error reporting, ConfigCat for feature flags, and the React Compiler with the matching ESLint plugin.",
        ],
        responsibilities: [
          "Implementing features end-to-end across iOS and Android — from forms and themed UI to API integration and native capabilities (HealthKit, notifications, deep links).",
          "Designing and maintaining reusable themed component primitives and form architecture used across the app.",
          "Owning the localization architecture — translation pipeline, reference-term sync, and translator-facing context.",
          "Closely collaborating with the Designer, Backend team, and Product Manager — clarifying requirements and making suggestions.",
          "Code review, planning, estimating, and resolving cross-platform bugs (with a strong focus on Android parity).",
          "Preparing, submitting and managing releases for both iOS and Android — working day-to-day in App Store Connect and Google Play Console (builds, TestFlight/internal testing, store listings, review submissions).",
          "Configuring in-app subscription products in App Store Connect and Google Play Console and wiring them to the app through RevenueCat (offerings, entitlements, sandbox testing).",
          "Proactively approaching projects to deliver high-quality user and development experiences.",
        ],
      },
    ],
  },
].reverse();
